document.addEventListener('DOMContentLoaded', function() {
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  let isUpdating = false;
  let updateQueued = false;
  let lastQuantityUpdate = null;

  function updateAllCartCounts(count) {
    
    const cartCounts = document.querySelectorAll('.sf-cart-count');
    cartCounts.forEach(counter => {
      counter.textContent = count;
      counter.setAttribute('data-count', count);
    });
    
    const cartCountHeader = document.querySelector('.scd__header h3');
    if (cartCountHeader) {
      cartCountHeader.textContent = `MY CART (${count})`;
    }
    
    const otherCartCounts = document.querySelectorAll('.cart-count, .cart-counter, [data-cart-count]');
    otherCartCounts.forEach(counter => {
      if (counter.tagName === 'INPUT') {
        counter.value = count;
      } else {
        counter.textContent = count;
      }
      counter.setAttribute('data-count', count);
    });
    
    const emptyMessage = document.querySelector('.scd-empty-msg');
    const itemsContainer = document.querySelector('.scd__items');
    const cartDrawerFooter = document.querySelector('.scd__footer');
    
    if (count === 0) {
      if (emptyMessage) {
        emptyMessage.style.display = 'block';
        emptyMessage.classList.remove('hidden');
      }
      if (itemsContainer) {
        itemsContainer.style.display = 'none';
        itemsContainer.classList.add('hidden');
      }
      if (cartDrawerFooter) {
        cartDrawerFooter.classList.add('hidden');
        cartDrawerFooter.style.display = 'none';
      }
    } else {
      if (emptyMessage) {
        emptyMessage.style.display = 'none';
        emptyMessage.classList.add('hidden');
      }
      if (itemsContainer) {
        itemsContainer.style.display = 'block';
        itemsContainer.classList.remove('hidden');
      }
      if (cartDrawerFooter) {
        cartDrawerFooter.classList.remove('hidden');
        cartDrawerFooter.style.display = 'block';
      }
    }
  }

  function openCartDrawer() {
    const cartDrawer = document.querySelector('.scd__wrapper');
    const cartDrawerContent = document.querySelector('.scd__content');
    
    if (cartDrawer && cartDrawerContent) {
      if (window.innerWidth < 770) {
        document.documentElement.classList.add('prevent-scroll');
        cartDrawer.classList.add('mobile');
      }
      
      cartDrawer.classList.remove('hidden');
      
      requestAnimationFrame(() => {
        cartDrawer.style.setProperty('--tw-bg-opacity', '0.5');
        cartDrawerContent.classList.remove('translate-x-full');
      });
    }
  }

  function closeCartDrawer() {
    const cartDrawer = document.querySelector('.scd__wrapper');
    const cartDrawerContent = document.querySelector('.scd__content');
    
    if (cartDrawer && cartDrawerContent) {
      cartDrawer.style.setProperty('--tw-bg-opacity', '0');
      cartDrawerContent.classList.add('translate-x-full');
      
      setTimeout(() => {
        cartDrawer.classList.add('hidden');
        cartDrawer.classList.remove('mobile');
        document.documentElement.classList.remove('prevent-scroll');
      }, 300);
    }
  }

  async function fetchCartSection() {
    try {
      const response = await fetch('/?section_id=cart-drawer');
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.text();
    } catch (error) {
      console.error('Error fetching cart section:', error);
      return null;
    }
  }

  const debouncedUpdateCartDrawer = debounce(async () => {
    if (isUpdating) {
      updateQueued = true;
      return;
    }

    isUpdating = true;
    
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      updateAllCartCounts(cart.item_count);

      const cartHTML = await fetchCartSection();
      if (cartHTML) {
        const tempContainer = document.createElement('div');
        tempContainer.innerHTML = cartHTML;
        
        const cartDrawer = document.querySelector('.scd__wrapper');
        if (!cartDrawer) return;

        const newHeader = tempContainer.querySelector('.scd__header');
        const currentHeader = document.querySelector('.scd__header');
        if (newHeader && currentHeader) {
          currentHeader.innerHTML = newHeader.innerHTML;
        }
        
        const newBody = tempContainer.querySelector('.scd__body');
        const currentBody = document.querySelector('.scd__body');
        if (newBody && currentBody) {
          currentBody.innerHTML = newBody.innerHTML;
        }

        const newSummary = tempContainer.querySelector('.scd__summary');
        const currentSummary = document.querySelector('.scd__summary');
        if (newSummary && currentSummary) {
          currentSummary.innerHTML = newSummary.innerHTML;
        }

        const newFooter = tempContainer.querySelector('.scd__footer');
        const currentFooter = document.querySelector('.scd__footer');
        if (newFooter && currentFooter) {
          currentFooter.innerHTML = newFooter.innerHTML;
          
          if (cart.item_count > 0) {
            currentFooter.classList.remove('hidden');
            currentFooter.style.display = 'block';
          } else {
            currentFooter.classList.add('hidden');
            currentFooter.style.display = 'none';
          }
        }

        const checkoutButton = currentFooter?.querySelector('[name="checkout"]');
        const subtotal = currentFooter?.querySelector('.scd__summary-subtotal');
        
        if (cart.item_count > 0) {
          if (checkoutButton) {
            checkoutButton.style.display = 'block';
            checkoutButton.classList.remove('hidden');
          }
          if (subtotal) {
            subtotal.style.display = 'block';
            subtotal.classList.remove('hidden');
          }
        }
      }
    } catch (error) {
      console.error('Error updating cart drawer:', error);
    } finally {
      isUpdating = false;
      if (updateQueued) {
        updateQueued = false;
        debouncedUpdateCartDrawer();
      }
    }
  }, 250);

  async function addToCart(variantId, quantity = 1) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: quantity
          }]
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const item = await response.json();
      
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      updateAllCartCounts(cart.item_count);
      
      await new Promise(resolve => {
        const updateCart = async () => {
          await debouncedUpdateCartDrawer();
          resolve();
        };
        updateCart();
      });

      if (typeof MinimogEvents !== 'undefined') {
        MinimogEvents.emit('ON_ITEM_ADDED', item);
        MinimogEvents.emit('ON_CART_UPDATE', cart);
      }

      openCartDrawer();

      return item;
    } catch (error) {
      console.error('Error adding to cart:', error);
      return null;
    }
  }

  async function removeItem(itemKey) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: 0
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const cart = await response.json();
      
      updateAllCartCounts(cart.item_count);
      
      await debouncedUpdateCartDrawer();

      if (typeof MinimogEvents !== 'undefined') {
        MinimogEvents.emit('ON_CART_UPDATE', cart);
      }

      return cart;
    } catch (error) {
      console.error('Error removing item:', error);
      return null;
    }
  }

  document.addEventListener('click', async function(event) {
    if (event.target.matches('.scd-item__btn')) {
      event.preventDefault();
      const button = event.target;
      const item = button.closest('.scd-item');
      const input = item?.querySelector('.scd-item__qty_input');
      
      if (item && input) {
        const currentQty = parseInt(input.value) || 0;
        
        let isIncrement = false;
        let isDecrement = false;
        
        if (button.classList.contains('scd-item__btn--inc')) isIncrement = true;
        else if (button.classList.contains('scd-item__btn--dec')) isDecrement = true;
        
        else if (button.dataset.qtyChange === 'inc') isIncrement = true;
        else if (button.dataset.qtyChange === 'dec') isDecrement = true;
        
        else if (button.textContent.includes('+')) isIncrement = true;
        else if (button.textContent.includes('-')) isDecrement = true;
        
        if (!isIncrement && !isDecrement) {
          return;
        }
        
        const newQty = isIncrement ? currentQty + 1 : Math.max(1, currentQty - 1);
        
        if (newQty !== currentQty) {
          input.value = newQty;
          
          const itemKey = item.dataset.id;
          if (itemKey) {
            try {
              button.classList.add('loading');
              button.disabled = true;
              
              const response = await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  id: itemKey,
                  quantity: newQty
                })
              });
              
              if (response.ok) {
                const cart = await response.json();
                
                const totalItems = cart.item_count;
                
                updateAllCartCounts(totalItems);
                
                const cartItem = cart.items.find(i => i.key === itemKey || i.id.toString() === itemKey);
                if (cartItem) {
                  input.value = cartItem.quantity;
                }
                
                await debouncedUpdateCartDrawer();
                
                if (typeof MinimogEvents !== 'undefined') {
                  MinimogEvents.emit('ON_CART_UPDATE', cart);
                }
              } else {
                console.error('Failed to update cart quantity');
                input.value = currentQty;
              }
            } catch (error) {
              console.error('Error updating cart:', error);
              input.value = currentQty;
            } finally {
              button.classList.remove('loading');
              button.disabled = false;
            }
          }
        }
      }
    }
    
    if (event.target.matches('.scd-item__remove') || event.target.closest('.scd-item__remove')) {
      event.preventDefault();
      const removeButton = event.target.closest('.scd-item__remove');
      const item = removeButton.closest('.scd-item');
      
      if (item) {
        const itemKey = item.dataset.id;
        if (itemKey) {
          try {
            removeButton.classList.add('loading');
            removeButton.disabled = true;
            
            const cart = await removeItem(itemKey);
            
            if (cart) {
              item.style.opacity = '0';
              item.style.transform = 'translateX(20px)';
              item.style.transition = 'all 0.3s ease-out';
              
              setTimeout(() => {
                item.remove();
              }, 300);
            }
          } catch (error) {
            console.error('Error removing item:', error);
          } finally {
            removeButton.classList.remove('loading');
            removeButton.disabled = false;
          }
        }
      }
    }
    
    if (event.target.matches('.sf-cart-icon') || event.target.closest('.sf-cart-icon')) {
      event.preventDefault();
      openCartDrawer();
    }

    if (event.target.matches('.pf-nst011-add-to-cart') || event.target.closest('.pf-nst011-add-to-cart')) {
      event.preventDefault();
      const button = event.target.closest('.pf-nst011-add-to-cart');
      const variantId = button.dataset.variantId;
      
      if (variantId) {
        try {
          button.classList.add('loading');
          button.disabled = true;
          
          const item = await addToCart(variantId);
          
          if (item) {
            button.classList.add('success');
            setTimeout(() => {
              button.classList.remove('success');
            }, 2000);
          }
        } catch (error) {
          console.error('Error adding item to cart:', error);
          button.classList.add('error');
          setTimeout(() => {
            button.classList.remove('error');
          }, 2000);
        } finally {
          button.classList.remove('loading');
          button.disabled = false;
        }
      }
    }
  });

  document.addEventListener('click', function(event) {
    if (event.target.matches('.scd__close') || event.target.closest('.scd__close')) {
      event.preventDefault();
      closeCartDrawer();
    }

    if (event.target.matches('.scd__wrapper')) {
      closeCartDrawer();
    }
  });

  if (typeof MinimogEvents !== 'undefined') {
    MinimogEvents.subscribe('ON_CART_UPDATE', (cart) => {
      if (cart) {
        updateAllCartCounts(cart.item_count);
      }
      debouncedUpdateCartDrawer();
    });
  }

  if (typeof Shopify !== 'undefined') {
    const originalOnItemAdded = Shopify.onItemAdded;
    Shopify.onItemAdded = async function(item) {
      try {
        if (originalOnItemAdded) {
          originalOnItemAdded(item, false);
        }

        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        
        updateAllCartCounts(cart.item_count);
        
        await new Promise(resolve => {
          const updateCart = async () => {
            await debouncedUpdateCartDrawer();
            resolve();
          };
          updateCart();
        });
        
        if (typeof MinimogEvents !== 'undefined') {
          MinimogEvents.emit('ON_CART_UPDATE', cart);
        }
        
        openCartDrawer();
      } catch (error) {
        console.error('Error in onItemAdded:', error);
      }
    };
  }

  document.addEventListener('cart:update', (event) => {
    if (event.detail && event.detail.cart) {
      updateAllCartCounts(event.detail.cart.item_count);
    }
    debouncedUpdateCartDrawer();
  });
  
  if (window.location.pathname.includes('/cart')) {
    
    const cartPageQtyInputs = document.querySelectorAll('input[name="updates[]"]');
    
    const updateCartCountFromServer = async () => {
      try {
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        updateAllCartCounts(cart.item_count);
      } catch (error) {
        console.error('Error updating cart count on cart page:', error);
      }
    };
    
    const cartIncButtons = document.querySelectorAll('.quantity-increment, .js-qty__adjust--plus, [data-action="increase-quantity"]');
    const cartDecButtons = document.querySelectorAll('.quantity-decrement, .js-qty__adjust--minus, [data-action="decrease-quantity"]');
    
    
    const handleQuantityButtonClick = () => {
      setTimeout(updateCartCountFromServer, 500);
    };
    
    cartIncButtons.forEach(btn => {
      btn.addEventListener('click', handleQuantityButtonClick);
    });
    
    cartDecButtons.forEach(btn => {
      btn.addEventListener('click', handleQuantityButtonClick);
    });
    
    cartPageQtyInputs.forEach(input => {
      const originalChangeHandler = input.onchange;
      
      input.onchange = async function(e) {
        if (originalChangeHandler) {
          originalChangeHandler.call(this, e);
        }
        
        setTimeout(updateCartCountFromServer, 500);
      };
    });
    
    const cartForm = document.querySelector('form[action="/cart"]');
    if (cartForm) {
      cartForm.addEventListener('submit', function(e) {
        setTimeout(updateCartCountFromServer, 500);
      });
    }
    
    updateCartCountFromServer();
  }
  
  debouncedUpdateCartDrawer();
}); 